import { hausperfektTheme } from '@/plugins/vuetify/themes'
import { useThemeStore } from '@/stores/system'
import { onBeforeMount, watch } from 'vue'
import { useTheme } from 'vuetify'

const getValidThemeValue = (
	clientVal: string | null,
	fallbackVal: string | undefined
) =>
	clientVal !== null && clientVal !== undefined && clientVal !== ''
		? clientVal
		: fallbackVal !== undefined && fallbackVal !== ''
			? fallbackVal
			: (() => {
					throw new Error('No valid theme value provided')
				})()

const mapThemeColors = (
	clientThemeOrColors: Api.ClientSetting | Record<string, string>,
	reverse: boolean = false
) => {
	if (!reverse) {
		// Map from clientTheme to colors
		const clientTheme = clientThemeOrColors as Api.ClientSetting
		return {
			background: getValidThemeValue(
				clientTheme?.bgcolor_f,
				hausperfektTheme?.colors?.background
			),
			nav: getValidThemeValue(
				clientTheme?.bgcolor_t,
				hausperfektTheme?.colors?.nav
			),
			primary: getValidThemeValue(
				clientTheme?.color_l,
				hausperfektTheme?.colors?.primary
			),
			secondary: getValidThemeValue(
				clientTheme?.color_a,
				hausperfektTheme?.colors?.secondary
			),
			table: getValidThemeValue(
				clientTheme?.color_z,
				hausperfektTheme?.colors?.table
			),
			text: getValidThemeValue(
				clientTheme?.color_t,
				hausperfektTheme?.colors?.text
			),
		}
	} else {
		// Map from colors to clientTheme
		const colors = clientThemeOrColors as Record<string, string>
		return {
			bgcolor_f: colors.background ?? hausperfektTheme?.colors?.background,
			bgcolor_t: colors.nav ?? hausperfektTheme?.colors?.nav,
			color_l: colors.primary ?? hausperfektTheme?.colors?.primary,
			color_a: colors.secondary ?? hausperfektTheme?.colors?.secondary,
			color_z: colors.table ?? hausperfektTheme?.colors?.table,
			color_t: colors.text ?? hausperfektTheme?.colors?.text,
		}
	}
}

export const useAppTheme = () => {
	const theme = useTheme()
	const themeStore = useThemeStore()

	watch(
		() => themeStore.theme,
		(value, oldValue) => {
			if (value && value !== oldValue) {
				theme.themes.value.client.colors = {
					...theme.themes.value.client.colors,
					...mapThemeColors(themeStore.theme),
				}
			}
		},
		{ immediate: true }
	)

	onBeforeMount(() => {
		if (themeStore.name) {
			theme.change(themeStore.name)
		}
	})

	function changeTheme(values: string[]) {
		const [value] = values
		if (!value) return

		themeStore.name = value
		theme.change(value)
	}

	return {
		changeTheme,
	}
}
